import { TEntity } from '@ws/shared/types';
import { PropsWithChildren } from 'react';
import { useDrop } from 'react-dnd';

interface Props extends PropsWithChildren {
  node: TEntity;
}

interface ICollected {
  isOver: boolean;
}

export function ListDropWrapper({ children }: Props) {
  const [, targetRef] = useDrop<null, null, ICollected>(
    () => ({
      accept: 'node',
      collect: (monitor) => ({ isOver: monitor.isOver({ shallow: true }) }),
      canDrop: () => false,
    }),
    [],
  );

  return <div ref={targetRef}>{children}</div>;
}
